import React, { Component } from 'react'
import { Player, BigPlayButton, ControlBar, Shortcut } from 'video-react'

class VideoPlayer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      playing: false
    }

    this.playSlideVideo = this.playSlideVideo.bind(this)
    this.stopSlideVideo = this.stopSlideVideo.bind(this)
    this.handleSlidePlayerState = this.handleSlidePlayerState.bind(this)
  }

  componentDidMount () {
    if (this.refs.slidePlayer) {
      this.refs.slidePlayer.subscribeToStateChange(this.handleSlidePlayerState)
    }
  }

  componentDidUpdate () {
    if (this.state.playing && this.props.activeSlide !== this.props.index) {
      this.stopSlideVideo()
    }
  }

  handleSlidePlayerState ({ ended }) {
    if (ended) {
      this.stopSlideVideo()
    }
  }

  playSlideVideo () {
    const { carouselVideo, slidePlayer } = this.refs

    carouselVideo.scrollIntoView()
    this.setState({
      playing: true
    }, () => {
      slidePlayer.play()
      this.props.clearTimer()
    })
  }

  stopSlideVideo () {
    const { slidePlayer } = this.refs
    slidePlayer.pause()
    slidePlayer.load()

    this.setState({
      playing: false
    }, () => {
      this.props.resetTimer()
    })
  }

  render () {
    const { playing } = this.state
    const {
      classes,
      index,
      activeSlide,
      item
    } = this.props

    return (
      <div
        ref='carouselVideo'
        key={item.id}
        className={activeSlide === index ? `${classes} ${classes}--active` : classes}
      >
        <Player
          className='video'
          ref='slidePlayer'
          aspectRatio='16:9'
          autoPlay={false}
          loop={false}
          muted={false}
          playsInline
          poster={item.image}
          preload='none'
          src={item.video}
        >
          <BigPlayButton disabled />
          <ControlBar disabled={!playing} />
          <Shortcut disabled={!playing} />
        </Player>
        {playing
          ? <div className='stop-button' onClick={this.stopSlideVideo} />
          : (<div
            className='play-button'
            onClick={this.playSlideVideo}
          />)
        }
      </div>
    )
  }
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./src/components/carousel-video.js